import { Paragraph, PrimaryFont, Title } from '../../typographies';
import { PrimaryButton, SecondaryButton, TertiaryButton } from '../../button';
import { FontAddiWeightBold } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall } from '@addi/foundation/dist/web/sizes';
import styled from 'styled-components';
export const Container = styled.div `
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
export const ErrorLayoutContainer = styled.div `
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;
export const ErrorScreenContainer = styled.div `
    display: flex;
    flex-direction: column;
    padding: 16px;
`;
export const ErrorScreenImage = styled.img `
    width: 100%;
    max-width: 310px;
    align-self: center;
`;
export const ErrorScreenTitle = styled(Title) `
    margin: 32px 0 16px;
`;
export const ErrorScreenLabel = styled(Paragraph) `
    font-size: ${SizeAddiFontSmall};
    margin: 0;
    line-height: 21px;
    letter-spacing: 0.02em;
`;
export const ErrorScreenActionContainer = styled.div `
    padding: 16px;
`;
export const ErrorScreenActionButton = styled(PrimaryButton) `
    width: 100%;
    user-select: none;
    ${PrimaryFont}
    font-weight: ${FontAddiWeightBold};
    font-size: ${SizeAddiFontSmall};
    border-radius: 24px;
`;
export const ErrorScreenTertiaryButton = styled(TertiaryButton) `
    width: 100%;
    user-select: none;
`;
export const ErrorScreenSecondaryButton = styled(SecondaryButton) `
    width: 100%;
    user-select: none;
    border-radius: 24px;
`;
//# sourceMappingURL=ErrorScreen.Styled.js.map